/**
 * Cart add /cart/add fetch patches for subscription chooser:
 * 1) Free gift batch line when subscription toggle is on (UPcart etc.).
 * 2) Bundle mode: force quantity from [data-quantity-input] onto FormData (must run after 1).
 *
 * Installed only when matching elements exist (PDP includes this script after the chooser).
 */
(function () {
  /**
   * @param {string | Request | URL} url
   */
  function isCartAddUrl(url) {
    if (typeof url === 'string') return url.indexOf('/cart/add') !== -1;
    if (url instanceof Request) return url.url.indexOf('/cart/add') !== -1;
    if (url instanceof URL) return url.href.indexOf('/cart/add') !== -1;
    return false;
  }

  function chooserIsSubscriptionActive() {
    var ch = document.querySelector('.subscription-chooser');
    if (!ch) return false;
    var toggle = ch.querySelector('.subscription-chooser__toggle-checkbox');
    return toggle ? toggle.checked : false;
  }

  function parseBodyToItems(body) {
    var items;
    var extraParams = {};
    if (body instanceof FormData) {
      var id = body.get('id');
      var quantity = body.get('quantity') || '1';
      var sellingPlan = body.get('selling_plan');
      if (!id || !sellingPlan) return null;
      /** @type {{ id: number; quantity: number; selling_plan: number; properties?: Record<string, string> }} */
      var mainItem = { id: Number(id), quantity: Number(quantity), selling_plan: Number(sellingPlan) };
      body.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && m[1]) {
          if (!mainItem.properties) mainItem.properties = {};
          mainItem.properties[m[1]] = String(value);
        }
      });
      items = [mainItem];
      var sections = body.get('sections') || body.get('sections[]');
      if (sections) extraParams.sections = sections;
    } else if (typeof body === 'string') {
      var parsed = JSON.parse(body);
      items = parsed.items || [parsed];
      if (parsed.sections) extraParams.sections = parsed.sections;
      var hasSelling = items.some(function (i) {
        return i.selling_plan;
      });
      if (!hasSelling) return null;
    } else {
      return null;
    }
    return { items: items, extraParams: extraParams };
  }

  /**
   * @param {number | string} giftVariantId
   */
  function installFreeGiftFetch(giftVariantId) {
    var nativeFetch = window.fetch;
    window.fetch = function (url, options) {
      if (
        options &&
        options.method &&
        options.method.toUpperCase() === 'POST' &&
        isCartAddUrl(url)
      ) {
        try {
          if (!chooserIsSubscriptionActive()) return nativeFetch.apply(this, arguments);
          var result = parseBodyToItems(options.body);
          if (!result) return nativeFetch.apply(this, arguments);

          var alreadyHasGift = result.items.some(function (i) {
            return String(i.id) === String(giftVariantId);
          });
          if (alreadyHasGift) return nativeFetch.apply(this, arguments);

          result.items.push({
            id: giftVariantId,
            quantity: 1,
            properties: { _subscription_free_gift: 'true' },
          });

          var payload = { items: result.items };
          if (result.extraParams.sections) payload.sections = result.extraParams.sections;

          var urlStr = typeof url === 'string' ? url : url.url;
          var cleanUrl = urlStr.split('?')[0];
          var newOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          };
          if (options.credentials) newOptions.credentials = options.credentials;
          if (options.signal) newOptions.signal = options.signal;
          return nativeFetch.call(this, cleanUrl, newOptions);
        } catch (e) {
          return nativeFetch.apply(this, arguments);
        }
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  function installBundleQuantityFetch() {
    var nativeFetch = window.fetch;
    window.fetch = function (url, options) {
      if (
        options &&
        options.body instanceof FormData &&
        options.method &&
        String(options.method).toUpperCase() === 'POST'
      ) {
        try {
          var urlStr = typeof url === 'string' ? url : url instanceof Request ? url.url : '';
          if (urlStr.indexOf('/cart/add') !== -1) {
            var ch = document.querySelector('.subscription-chooser[data-bundle-mode="true"]');
            var qi = ch && ch.querySelector('[data-quantity-input]');
            if (qi) {
              var q = parseInt(String(qi.value), 10);
              if (Number.isFinite(q) && q >= 1) {
                options.body.set('quantity', String(q));
              }
            }
          }
        } catch (e) {
          /* ignore */
        }
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  var giftRoot = document.querySelector('.subscription-chooser[data-free-gift-enabled="true"]');
  if (giftRoot) {
    var rawId = giftRoot.getAttribute('data-free-gift-variant-id');
    if (rawId && String(rawId).trim() !== '') {
      var gid = Number(rawId);
      if (Number.isFinite(gid)) {
        installFreeGiftFetch(gid);
      }
    }
  }

  if (document.querySelector('.subscription-chooser[data-bundle-mode="true"]')) {
    installBundleQuantityFetch();
  }
})();
